import { inject, Injectable } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { CaseApiService } from 'app/domain/cases/api/case-api.service';
import { Case, CaseRequest } from 'app/domain/cases/case.model';

@Injectable({ providedIn: 'root' })
export class CaseCreationState {
  private readonly caseApi = inject(CaseApiService);

  private created: Case | undefined;

  create(caseRequest: CaseRequest): Observable<string> {
    return this.caseApi.create(caseRequest).pipe(
      tap((created) => (this.created = created)),
      map((created) => created.reference),
    );
  }

  load(reference: string): Observable<Case> {
    if (this.created?.reference === reference) {
      return of(this.created);
    }
    return this.caseApi.get(reference).pipe(tap((loaded) => (this.created = loaded)));
  }
}
